import React from "react";
import "./tabPanel.css";

export interface TabItem {
  label: string;
  content: React.ReactNode;
}

interface TabPanelProps {
  tabs: TabItem[];
  name: string;
  title: string;
  defaultOpenIndex?: number;
  className?: string;
}

const TabPanel: React.FC<TabPanelProps> = ({
  tabs,
  name,
  title,
  defaultOpenIndex = 0,
  className = "",
}) => {
  return (
    <div className="tabPanel-container">
      <div className="comparisonTable-header">
        <h3 className="comparisonTable-title">{title.toUpperCase()}</h3>
      </div>

      <div className={`tabPanel-tab-container ${className}`}>
        <div className="tabPanel-tabs">
          {tabs.map((tab, index) => (
            <details
              key={`${name}-${index}`}
              className="tabPanel-item"
              open={index === defaultOpenIndex}
              name={name}
            >
              <summary className="tabPanel-link">{tab.label}</summary>
              <div className="tabPanel-body">{tab.content}</div>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabPanel;
